import * as React from 'react';
import { PortalContext, Link, HomeWidget } from '@portal/arq-portal-core';
import { makeStyles } from '@material-ui/core';
import { InformeMicroStrategy } from '../types/types';
import useInformesAutos from '../hooks/informesAutos';

const useStyles = makeStyles({
  reportes: {
    '& a': {
      fontSize: '12px',
      fontWeight: '400',
      textDecorationLine: 'underline',
      marginTop: '10px',
      fontFamily: 'Catalana-sans, Arial, sans-serif'
    }
  },
  linkReportes: {
    marginTop: '10px'
  }
});

export const ReportesMicrostrategy = (props:any) => {

  const {user} = React.useContext(PortalContext);
  const {data, error} = useInformesAutos(user?user.id:"");
  const clases = useStyles(props);
  let errorMessage = error?.message ? error.message : error?.mensaje ? error.mensaje : error;
  let informes: InformeMicroStrategy[]  = props?.informes? props.informes: data?.Salida?.InformesMicroStrategy;

  if(!data && errorMessage){
    console.log(errorMessage);
  }

  if(data && informes?.length > 0){
    return <React.Fragment>
      <HomeWidget titulo="Reportes Microstrategy" className={clases.reportes}>
        <div className={clases.linkReportes}>
          <Link to="/prepersanet/reportesmicrostrategy">Ver resultados</Link>
        </div>
      </HomeWidget>
    </React.Fragment>
  }else{
    return (null);
  }
}